const push = (eventName, data) =>
	new Promise((resolve, reject) => {
		if (!eventName) {
			reject('No eventName specified to Facebook')
		}

		if (window['fbq']) {
			if (process.env.GATSBY_GOOGLE_SERVICE_LOG === 'true') {
				console.info('Pushing to Facebook: ', data)
			}
			resolve(window.fbq('track', eventName, data))
		} else {
			if (data.eventCallback) {
				data.eventCallback()
			}
			reject('Facebook not installed')
		}
	})

export const pushBooking = async () => {
	return push('Schedule', null)
}

export const pushSubscribe = async (
	subscriptionValue,
	currency,
	predictedLtv,
) => {
	return push('Subscribe', {
		value: subscriptionValue,
		currency: currency,
		predicted_ltv: predictedLtv,
	})
}
